import { render } from "./MyMake.vue?vue&type=template&id=4ecdcdd2&scoped=true"
import script from "./MyMake.vue?vue&type=script&lang=js"
export * from "./MyMake.vue?vue&type=script&lang=js"

import "./MyMake.vue?vue&type=style&index=0&id=4ecdcdd2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4ecdcdd2"]])

export default __exports__